import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import {Skeleton} from '../../../components/Skeleton';

export const BREAKPOINT_TWO_COL_PX = 1360;
export const BREAKPOINT_ONE_COL_PX = 900;
export const BREAKPOINT_MOBILE_ONE_COL_PX = 666;

export const Grid = styled.div<{numColumns: number}>`
  align-items: center;
  display: grid;
  white-space: nowrap;
  margin-bottom: 10px;
  grid-template-columns: repeat(${props => props.numColumns}, minmax(0, 1fr));
  grid-gap: 10px;
  margin-bottom: 40px;

  @media (max-width: ${BREAKPOINT_TWO_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  @media (max-width: ${BREAKPOINT_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  }
  @media (max-width: ${globals.TABLET_BREAKPOINT}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
  }
  @media (max-width: ${BREAKPOINT_MOBILE_ONE_COL_PX}px) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  }
`;
Grid.displayName = 'S.Grid';

export const CardDescription = styled.div`
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  color: ${globals.MOON_500};
  font-family: Source Sans Pro;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  align-items: center;
`;
CardDescription.displayName = 'S.CardDescription';

export const EmptyCard = styled.div`
  border-radius: 8px;
  border: 1px dashed ${globals.MOON_250};
  background: transparent;
  height: 100%;
`;
EmptyCard.displayName = 'S.EmptyCard';

export const skeletonCardContent = css`
  white-space: nowrap;
  overflow: hidden;
  background: ${globals.WHITE};
  color: ${globals.TEXT_PRIMARY_COLOR};
  border: 1px solid ${globals.MOON_200};
  border-radius: 8px;
  padding: calc(${globals.spu} * 1.375);
  transition: border-color 0.3s;
`;

export const cardContent = css`
  overflow: hidden;
  white-space: nowrap;
  background: ${globals.WHITE};
  color: ${globals.TEXT_PRIMARY_COLOR};
  &:hover {
    color: ${globals.TEXT_PRIMARY_COLOR};
  }
  border: 1px solid ${globals.MOON_200};
  &:hover {
    border-color: ${globals.TEAL_450};
  }
  border-radius: 8px;
  padding: calc(${globals.spu} * 1.375);
  transition: border-color 0.3s;
`;

export const SkeletonText = styled(Skeleton)<{width?: number}>`
  display: flex;
  width: ${props => (props.width ? props.width + 'px' : '100%')};
  max-width: 100%;
`;
SkeletonText.displayName = 'S.SkeletonText';

export const SkeletonCard = styled.div`
  ${skeletonCardContent}
`;
SkeletonCard.displayName = 'S.SkeletonCard';

export const clampStyles = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
